<template>
  <div>
    <basic-container>
      <div>
        <el-form
          ref="form"
          :model="projectItemForm"
          disabled
        >

          <el-form-item
            label="工程项目名称"
            label-width="100px"
          >

            <div style="display: flex;width:300px;">
              <el-input
                v-model="projectItemForm.name"
                placeholder='请输入工程项目名称'
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item
            label="关联服务商"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-select
                v-model="projectItemForm.agentId"
                placeholder="请选择关联服务商"
                width="200"
                @change="aasscc"
              >
                <el-option
                  v-for="item in agentIds"
                  :key="item.id"
                  :label="item.company"
                  :value='item.id'
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="工程预约配置">
            <el-table
              :data="tableData"
              :span-method="objectSpanMethod"
              border
              style="width: 100%; margin-top: 20px"
            >

              <el-table-column
                prop="clientType"
                align="center"
                label="预约渠道"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.clientType"
                    placeholder="请选择预约渠道"
                    width="300"
                  >
                    <el-option
                      v-for="item in clientTypes"
                      :key="item.value"
                      :label="item.label"
                      :value='item.value'
                    ></el-option>
                  </el-select>
                </template>

              </el-table-column>

              <el-table-column
                prop="auditor"
                align="center"
                label="审核方"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.auditor"
                    placeholder="审核方"
                    width="300"
                  >
                    <el-option
                      v-for="item in auditors"
                      :key="item.value"
                      :label="item.label"
                      :value='item.value'
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="payer"
                align="center"
                label="支付方"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.payer"
                    placeholder="请选择支付方"
                    width="300"
                  >
                    <el-option
                      v-for="item in payers"
                      :key="item.value"
                      :label="item.label"
                      :value='item.value'
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="area"
                min-width="120"
                align="center"
                label="服务区域"
              >
                <template slot-scope="scope">
                  <div>
                    <div>
                      <el-select
                        v-model="scope.row.provinces"
                        size="small"
                        @change="chooseProvince(scope.row.provinces,scope)"
                        placeholder="请选择省份"
                        value-key="id"
                      >
                        <el-option
                          v-for="item in provinces"
                          :key="item.id"
                          :label="item.name"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </div>
                    <div>
                      <el-select
                        v-model="scope.row.citys"
                        size="small"
                        @change="chooseCity(scope.row.citys,scope)"
                        value-key="id"
                        placeholder="请选择城市"
                      >
                        <el-option
                          v-for="item in scope.row.citysList"
                          :key="item.id"
                          :label="item.name"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </div>
                    <div>
                      <el-select
                        v-model="scope.row.areas"
                        size="small"
                        @change="chooseArea(scope.row.areas,scope)"
                        value-key="id"
                        placeholder="请选择地区"
                      >
                        <el-option
                          v-for="item in scope.row.areasList"
                          :key="item.id"
                          :label="item.name"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="工程阶段配置">
            <el-table
              :data="tableData1"
              :span-method="objectSpanMethod"
              border
              style="width: 100%; margin-top: 20px"
            >

              <el-table-column
                prop="name"
                align="center"
                label="工程阶段名称"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-input
                    type="input"
                    name="name"
                    size="small"
                    v-model="scope.row.name"
                    :value="scope.row.name"
                    placeholder="请输入工程阶段名称"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column
                prop="isVisit"
                align="center"
                label="工程费用"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-radio
                    v-model="scope.row.isVisit"
                    label="YES"
                  >
                    有
                  </el-radio>
                  <el-radio
                    v-model="scope.row.isVisit"
                    label="NO"
                  >
                    无
                  </el-radio>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="engineeringCost"
                label="工程费用明细"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-input
                    type="input"
                    name="engineeringCost"
                    size="small"
                    v-if="scope.row.isVisit =='YES'"
                    v-model="scope.row.engineeringCost"
                    :value="scope.row.engineeringCost"
                    placeholder="请输入工程费用明细"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="sort"
                label="排序"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-input
                    type="input"
                    name="sort"
                    size="small"
                    v-model="scope.row.sort"
                    :value="scope.row.sort"
                    placeholder="排序"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <div style='width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px'>
          <el-button
            type="primary"
            size="big"
            @click="submit"
          >返回上级</el-button>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { resolveUrlPath, setUrlPath } from "@/util/util";
import {
  findAllSuperiorDepartment,
  findEngineeringProjectDetail,
  editEngineeringProject,
  findProvince,
  findCitys,
  findAreas
} from "@/api/work/projectItem";

export default {
  data() {
    return {
      projectItemForm: {},
      isTop: "YES",
      clientTypes: DIC.SERVICEITEM_TYPE,
      payers: DIC.SERVICEITEM_PAYER,
      auditors: DIC.SERVICEITEM_AUDITOR,
      agentIds: [],
      areas: [],
      citys: [],
      provinces: [],
      tableData: [],
      tableData1: []
    };
  },
  created() {
    findEngineeringProjectDetail(this.$router.currentRoute.query.id).then(
      res => {
        let data = JSON.parse(res.data);
        this.projectItemForm.name = this.$router.currentRoute.query.aname;
        this.projectItemForm.agentId = this.$router.currentRoute.query.agentId;
        this.tableData1 = data.stageRequestList;
        for (let j of data.stageRequestList) {
          if (j.engineeringCost) {
            j.isVisit = "YES";
          } else {
            j.isVisit = "NO";
          }
        }
        for (let i of data.reservationConfigList) {
          i.provinces = {};
          i.provinces.id = i.province;
          i.provinces.name = i.provinceName;

          i.citysList = [];
          let cityobj = {};
          cityobj.id = i.city;
          cityobj.name = i.cityName;
          i.citysList.push(cityobj);
          i.citys = {};
          i.citys.id = i.city;
          i.citys.name = i.cityName;

          i.areasList = [];
          let areaobj = {};
          areaobj.id = i.area;
          areaobj.name = i.areaName;
          i.areasList.push(areaobj);
          i.areas = {};
          i.areas.id = i.area;
          i.areas.name = i.areaName;
        }
        this.tableData = data.reservationConfigList;
      }
    );
    findAllSuperiorDepartment().then(res => {
      let data = JSON.parse(res.data);
      console.log(data);

      this.agentIds = data;
      this.agentIds.unshift({ company: "社区", id: "0" });
    });
    findProvince().then(res => {
      // let data = JSON.parse(res.data);
      console.log(res);
      this.provinces = res.data;
      this.currentProvince = "";
      this.currentCity = "";
      this.currentArea = "";
    });
  },
  methods: {
    aasscc() {},
    chooseProvince(provinces, scope) {
      console.log(provinces);
      console.log(scope);
      findCitys(provinces.id).then(res => {
        //   console.log(res);
        scope.row.citysList = res.data;
        scope.row.citys = {};
        scope.row.areas = {};
        //   console.log(scope);
      });
    },
    chooseCity(citys, scope) {
      findAreas(citys.id).then(res => {
        scope.row.areasList = res.data;
        scope.row.areas = {};
      });
    },
    chooseArea(areas, scope) {
      console.log(areas);
    },
    submit() {
      let item = {
        close: true,
        label: "查看工程项目",
        value: "/work/projectItem/view"
      };
      // this.$store.commit("DEL_TAG", item);
      // let obj = {
      //   value: "/work/projectItem",
      //   label: "工程项目管理"
      // };
      // this.$router.push({
      //   path: resolveUrlPath(obj.value, obj.label),
      //   query: obj.query
      // });

      this.$store.commit("DEL_TAG", item);
      let obj = {
        value: "/work/projectItem",
        label: "工程项目管理"
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query
      });
    },
    handleSteppingDelete(index, row) {
      //   this.propertiesList.splice(index, 1);

      this.tableData.splice(index, 1);
    },
    handleStepping1Delete(index, row) {
      //   this.propertiesList.splice(index, 1);

      this.tableData1.splice(index, 1);
    },
    handleAddRows(index, row) {
      let list = {};
      this.tableData.push(list);
    },
    handleAdd1Rows(index, row) {
      let list = {
        isVisit: "YES"
      };
      this.tableData1.push(list);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 8) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
};
</script>

<style>
</style>